import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as LogoHeader } from '../../../assets/logo-color.svg';
import { PHONE_NUMBER } from "../../../utils/types/NavigationLinks";


const LogoSection: FunctionComponent = () => (
  <div className="flex items-center">
    <CompanyLogo />
    <PhoneNumber />
  </div>
);


const CompanyLogo: FunctionComponent = () => (
  <Link to={'/'}>
    <LogoHeader id="header-logo" height='100px' width='160px' />
  </Link>
);


const PhoneNumber: FunctionComponent = () => (
  <p className="ml-8 mt-3 text-xl text-primary">
    {PHONE_NUMBER}
  </p>
);


export default LogoSection;


